import { ActionsCell } from '../../../Component/Common/Components/DataTable/ActionsCell';
import { DefaultCell } from '../../../Component/Common/Components/DataTable/DefaultCell';
import { ActionType, TableColumn } from '../../../Component/Model/Table/Table';
import { Typography } from '@mui/material';
import {
  VAClientApplicationData, VerificationAgencyClientApplication
} from "../../../Component/Model/Dto/VerificationAgency/VerificationAgencyClientApplication";
import { TableDateHelper } from '../../../Component/Model/helpers';

interface VAClientApplicationRow {
  VAClientApplicationId: number;
  VAClientId: number;
  VAClientCompanyName?: string;
  ServiceRequired?: string;
  ReferenceNumber: ILinkProps;
  CreatedDate: string;
  SendDate?: string;
  ReceivedDate?: string;
  Actions: ActionType[];
}

interface ILinkProps {
  itemId: number;
  itemName: string;
}


export interface VAClientApplicationTable {
  columns: Array<TableColumn>;
  rows: Array<VAClientApplicationRow>;
}

export function VAClientApplicationTableMapper(dataObject: VAClientApplicationData[], deleteApplication: (application: VerificationAgencyClientApplication.ClientApplicationDetailsDto) => void, sendApplication: (application: VerificationAgencyClientApplication.ClientApplicationDetailsDto) => void, setApplication: (id: number, appId: number, name: string) => void, allClients: boolean): VAClientApplicationTable {
  const allClientsColumns = [
    { Header: 'Application Reference', accessor: 'ReferenceNumber', Cell: ({ value }: any) => <Typography variant="caption" fontWeight='regular' color="#007bff" style={{ cursor: "pointer" }} onClick={() => setApplication(value.itemId, value.itemApplicationId, value.itemCompanyName)}>{value.itemName}</Typography> },
    { Header: 'Company Name', accessor: 'VAClientCompanyName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Service Required', accessor: 'ServiceRequired', id: 'ServiceId', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Application Created', accessor: 'CreatedDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Application Sent', accessor: 'SendDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Application Received', accessor: 'ReceivedDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
  ];

  const clientColumns = [
    { Header: 'Application Reference', accessor: 'ReferenceNumber', Cell: ({ value }: any) => <Typography variant="caption" fontWeight='regular' color="#007bff" style={{ cursor: "pointer" }} onClick={() => setApplication(value.itemId, value.itemApplicationId, value.itemCompanyName)}>{value.itemName}</Typography> },
    { Header: 'Service Required', accessor: 'ServiceRequired', id: 'ServiceId', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Application Created', accessor: 'CreatedDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Application Sent', accessor: 'SendDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Application Received', accessor: 'ReceivedDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
    { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
  ];

  const columns = allClients === true ? allClientsColumns : clientColumns;

  if (dataObject && dataObject.length > 0) {
    const rows = dataObject.map((item: VAClientApplicationData, index: number) => ({
      VAClientApplicationId: item.vaClientApplicationId,
      VAClientId: item.vaClientId,
      VAClientCompanyName: item.vaClientCompanyName,
      ServiceRequired: item.serviceRequired,
      ReferenceNumber: { itemId: item.vaClientId, itemName: item.referenceNumber, itemApplicationId: item.vaClientApplicationId , itemCompanyName: item.vaClientCompanyName},
      CreatedDate: item.createdDate !== null ? TableDateHelper(new Date(item.createdDate).toUTCString()) : "",
      SendDate: item.sendDate !== null ? TableDateHelper(new Date(item.sendDate).toUTCString()) : "",
      ReceivedDate: item.receivedDate !== null ? TableDateHelper(new Date(item.receivedDate).toUTCString()) : "",
      Actions: [
        {
          key: index.toString(),
          label: 'Send Application',
          action: () => {
            const sendData = {
              vaClientApplicationId: item.vaClientApplicationId,
              vaClientId: item.vaClientId,
              active: false,
            } as VerificationAgencyClientApplication.ClientApplicationDetailsDto;

            sendApplication(sendData);
          },
          icon: {
            color: 'grey',
            name: 'send'
          }
        },
        {
          key: index.toString(),
          label: 'Delete',
          action: () => {
            const deleteData = {
              VAClientApplicationId: item.vaClientApplicationId,
              vaClientId: item.vaClientId,
              active: false
            } as VerificationAgencyClientApplication.ClientApplicationDetailsDto;

            deleteApplication(deleteData);
          },
          icon: {
            color: 'error',
            name: 'delete'
          }
        }
      ]

    }));
    return { columns: columns, rows: rows };
  }
  else {
    return { columns: columns, rows: [] };
  }
}

